import { BeneficiaryEntityType, BeneficiaryTransferDestination } from 'types/beneficiaries'

export const DEFAULT_FIAT_INSTRUMENT = {
  sourceWalletLsid: '',
  // Basic beneficiary details
  transferDestination: BeneficiaryTransferDestination.LOCAL,
  entityType: BeneficiaryEntityType.BUSINESS,
  description: '',
  currency: '',
  isSelfOwned: false,
  beneficiaryAddressLine1: '',
  beneficiaryAddressLine2: '',
  beneficiaryCity: '',
  beneficiaryRegion: '',
  beneficiaryPostCode: '',
  beneficiaryCountryCode: '',
  // Bank account details
  accountNumber: '',
  bankCode: '',
  routingNumber: '',
  accountType: '',
  paymentMethod: '',
  bankName: '',
  bankAddressLine1: '',
  bankAddressLine2: '',
  bankCity: '',
  bankRegion: '',
  bankPostCode: '',
  bankCountryCode: '',
  // Intermediary bank details
  intermediaryBankCode: '',
  intermediaryBankRoutingNumber: '',
  intermediaryBankName: '',
  intermediaryBankAddressLine1: '',
  intermediaryBankAddressLine2: '',
  intermediaryBankCity: '',
  intermediaryBankRegion: '',
  intermediaryBankPostCode: '',
  intermediaryBankCountryCode: '',
}

// Address fields
export const MIN_LENGTH = 2
export const MAX_LENGTH = 200
export const ADDRESS_LINE_MAX_LENGTH = 35
export const ADDRESS_FIELDS_REQUIRED_TOGETHER = ['addressLine1', 'city', 'postCode', 'region']

export const CURRENCY_RESET_FIELDS = [
  'description',
  'accountNumber',
  'accountNumberConfirm',
  'bankCode',
  'routingNumber',
  'accountType',
  'bankName',
  'bankAddressLine1',
  'bankAddressLine2',
  'bankCity',
  'bankRegion',
  'bankPostCode',
  'bankCountryCode',
  'bankCountryName',
  'bankNameCode',
  'intermediaryBankCode',
  'intermediaryBankRoutingNumber',
  'intermediaryBankName',
  'intermediaryBankAddressLine1',
  'intermediaryBankAddressLine2',
  'intermediaryBankCity',
  'intermediaryBankRegion',
  'intermediaryBankPostCode',
  'intermediaryBankCountryCode',
] as const

export const TRANSFER_DESTINATION_RESET_FIELDS = ['currency', ...CURRENCY_RESET_FIELDS] as const
